import React, { Component } from "react";
import PropTypes from "prop-types";

import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import * as moment from "moment";
import { isEmpty, size } from "lodash";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
} from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
const { SearchBar, ClearSearchButton } = Search;

import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";

import {
  Badge,
  Col,
  Container,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Row,
  UncontrolledDropdown,
  Modal,
  ModalHeader,
  ModalBody,
  Label,
  Button,
  Card,
  CardBody,
} from "reactstrap";

import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
import DeleteModal from "components/Common/DeleteModal";
import VerifyModal from "components/Common/VerifyModal";
import { map } from "lodash";

//Import Image
import images from "assets/images";
import companies from "assets/images/companies";

import {
  getOrders,
  addNewOrder,
  updateOrder,
  deleteOrder,
} from "store/actions";
import { getLabsListRequest, getLabsListFail,getAllLabsListRequest, deletepLabSuccess,
    deletepLabFail, deletepLabRequest, verifyLabSuccess,
    verifyLabFail, verifyLabRequest   } from "store/actions";

import EcommerceOrdersModal from "../Ecommerce/EcommerceOrders/EcommerceOrdersModal";

const MySearchBar = prop => {
  console.log(JSON.stringify(prop))
  let input;
  const handleClick = () => {
    prop.onSearch(input.value);
  };

  return (
    <div className="app-search">
      <div className="position-relative">
        <input
          type="text"
          className="form-control bg-white border border-3 shadow w-100"
          placeholder={"Search " + "..."}
          ref={ n => input = n }
          onChange={handleClick}
        />
        <span className="bx bx-search-alt"></span>
      </div>
    </div>
  );
};
class VerifiedLabs extends Component {
  constructor(props) {
    super(props);
    this.node = React.createRef();
    this.state = {
      viewmodal: false,
      modal: false,
    
    labs: [],
      order: "",
      lab: "",
      deleteModal: false,
      verifyModal:false,
      LabListColumns: [
     
        {
            dataField: "email",
            text: "Lab Email",
            sort: true,
          },
          {
            dataField: "name",
            text: "Lab Name",
            sort: true,
            hidden: false,
          },
          {
            dataField: "landline_number",
            text: "Landline Number",
            sort: true,
          },
          {
            dataField: "health_department_id",
            text: "Health Department",
            sort: true,
          },
          
        {
          dataField: "view",
          isDummyField: true,
          text: "View Details",
          sort: true,
          formatter: (cellContent, row) => (
            console.log({ pathname: `/lab-overview/${row.email}` }),
            (
              <Link
                to={{ pathname: `/lab-overview/${row.email}` }}
                className="btn btn-primary btn-sm btn-rounded"
              >
                View Details
              </Link>
            )
          ),
        },
        
        {
          dataField: "action",
          isDummyField: true,
          text: "Action",
          formatter: (cellContent,lab) => (
            <>
              <div className="d-flex gap-3">
                <Link to="#" className="text-danger">
                <i
                 onClick={() => this.onClickVerify(lab)}
                className="bi bi-check-all font-size-16 text-success me-1"
              />
                  <i
                    className="mdi mdi-trash-can font-size-16 text-danger me-1"
                    style={{
                      cursor: "pointer",
                    }}
                    id="deletetooltip"
                    onClick={() => this.onClickDelete(lab)}
                    
                  />
                </Link>
              </div>
            </>
          ),
        },
      ],
    };

    this.handleEditClick = this.handleEditClick.bind(this);
    this.toggle = this.toggle.bind(this);
    this.handleEditTestClicks = this.handleEditTestClicks.bind(this);
    this.toLowerCase1 = this.toLowerCase1.bind(this);
    this.onClickDelete = this.onClickDelete.bind(this);
  }

  toLowerCase1(str) {
    return str.toLowerCase();
  }

  componentDidMount() {
    const { labs, onGetLab } = this.props;
    if (labs && !labs.length ) {
      onGetLab();//CHECK THIs
      console.log("pending")
      this.setState({ labs });
    }
    this.setState({ labs });
    onGetLab()
    this.setState({ labs });
    
    

  }
  

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { labs, onGetLab } = this.props;
    if (!isEmpty(labs) && size(prevProps.labs) !== size(labs)) {
      this.setState({ labs: {} });
      console.log("LABS",this.state.labs)
    }
  }

  toggle() {
    this.setState(prevState => ({
      modal: !prevState.modal,
    }));
  }

  handleEditTestClicks = () => {
    this.setState({ lab: "" });
    this.toggle();
  };

  toggleViewModal = () => {
    this.setState(prevState => ({
      viewmodal: !prevState.viewmodal,
    }));
  };

  onPaginationPageChange = page => {
    if (
      this.node &&
      this.node.current &&
      this.node.current.props &&
      this.node.current.props.pagination &&
      this.node.current.props.pagination.options
    ) {
      this.node.current.props.pagination.options.onPageChange(page);
    }
  };

  /* Insert,Update Delete data */

  toggleDeleteModal = () => {
    this.setState(prevState => ({
      deleteModal: !prevState.deleteModal,
    }));
  };
  toggleVerifyModal = () => {
    this.setState(prevState => ({
      verifyModal: !prevState.verifyModal,
    }));
  };

  onClickDelete = (lab) => {
    this.setState({ lab: lab });
    this.setState({ deleteModal: true });
    console.log("lab", lab);
  };
  onClickVerify = (lab) => {
    this.setState({ lab: lab });
    this.setState({ verifyModal: true });
    console.log("lab for verification", lab);
  };

  handleDeleteTest = () => {
    const { onDeleteLab } = this.props;
    const { lab } = this.state;
    if (lab.email !== undefined) {
      onDeleteLab(lab);
      this.onPaginationPageChange(1);
      this.setState({ deleteModal: false });
      window.location.reload()
    }
    console.log("lab in handledelete", lab);
  };
  handleVerifyLab = () => {
    const { onVerifyLab } = this.props;
    const { lab } = this.state;
    console.log("in handle verification")
    if (lab.email !== undefined) {
      onVerifyLab(lab);
      this.onPaginationPageChange(1);
      this.setState({ verifyModal: false });
      window.location.reload()
    }
    console.log("lab in handleverification", lab);
  };

  handleEditClick = arg => {
    const order = arg;
    const lab =arg
    this.setState({
      lab: {
        email: lab.email,
        name: lab.name,
        landline_number: lab.landline_number,
        health_department_id: lab.health_department_id,
        address: lab.address,
        contact_number: lab.contact_number,
        
      },
     // isEdit: true,
    });

    this.toggle();
  };

  // handleTestEditClick = () => {
  //   this.setState({ test: "" });
  //   this.toggle();
  // };

  
  

  render() {
   
    const { labs } = this.props;
    
    console.log("In Render",this.state.labs)  

    const { SearchBar } = Search;

    const { isEdit, deleteModal , verifyModal} = this.state;

    //pagination customization
    const pageOptions = {
      sizePerPage: 10,
      totalSize: labs.length, 
      custom: true,
    };

    const defaultSorted = [
      {
         dataField: "name",
        order: "asc",
      },
    ];

    const selectRow = {
      mode: "checkbox",
    };

    return (
      <React.Fragment>
        
        <DeleteModal
          show={deleteModal}
          onDeleteClick={this.handleDeleteTest}
          onCloseClick={() => this.setState({ deleteModal: false })}
        />
        <VerifyModal
          show={verifyModal}
          onVerifyClick={this.handleVerifyLab}
          onCloseClick={() => this.setState({ verifyModal: false })}
        />
      
       
        <div className="page-content">
        
          <Container fluid>
            
            <Breadcrumbs title="Dashboard" breadcrumbItem=" Pending Verifications" />
            {this.props.loading && (
              <div className="text-center " style={{}}>
                <i
                  className="bx bx-loader bx-spin align-middle me-2"
                  style={{ fontSize: 48, color: "#2A3042" }}
                />
              </div>
            )}
            {!isEmpty(labs) && !this.props.loading && (
              <>


            
            <Row>
              <Col xs="12">
                <Card>
                  <CardBody>
                    <PaginationProvider
                      pagination={paginationFactory(pageOptions || [])}
                      keyField="id"
                      columns={this.state.LabListColumns || []}
                      data={labs || []}
                    >
                      {({ paginationProps, paginationTableProps }) => (
                        <ToolkitProvider
                          keyField="id"
                          data={labs}
                          columns={this.state.LabListColumns || []}
                          bootstrap4
                          search
                         
                        >
                          {toolkitProps => (
                            <React.Fragment>
                  
                              <Row className="mb-2">
                                <Col sm="8">
                                  <div className="app-search">
                                    <div className="position-relative">        
                                      <MySearchBar {...toolkitProps.searchProps} />
                                    </div>
                                  </div>
                                </Col>
                               <Col sm={2}></Col>
                                <Col sm={2}
                                className=" d-flex  justify-content-end align-items-center">
                                 
                                </Col>
                              </Row>
                              <div className="table-responsive">
                                <BootstrapTable
                                  {...toolkitProps.baseProps}
                                  {...paginationTableProps}
                                  responsive
                                  defaultSorted={defaultSorted}
                                  bordered={false}
                                  striped={false}
                                  selectRow={selectRow}
                                  classes={
                                    "table align-middle table-nowrap table-check"
                                  }
                                  headerWrapperClasses={"table-light"}
                                  ref={this.node}
                                />
                                {/* {this.props.loading && (
              <div className="text-center " style={{

              }}>
                <i className="bx bx-loader bx-spin align-middle me-2" style={{fontSize:48,color:'#2A3042'}}/>
              </div>
            )} */}
                                <Modal
                                  isOpen={this.state.modal}
                                  className={this.props.className}
                                >
                                </Modal>
                              </div>
                              <div className="pagination pagination-rounded justify-content-end mb-2">
                                <PaginationListStandalone
                                  {...paginationProps}
                                />
                              </div>
                            </React.Fragment>
                          )}
                        </ToolkitProvider>
                      )}
                    </PaginationProvider>
                  </CardBody>
                </Card>
              </Col>
            </Row>
            </>
            )}
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

VerifiedLabs.propTypes = {
  className: PropTypes.any,
  labs: PropTypes.array,
  onGetLab: PropTypes.func,
  onUpdateTest: PropTypes.func,
  onDeleteLab: PropTypes.func,
  onVerifyLab: PropTypes.func,
  loading: PropTypes.bool,
};

const mapStateToProps = state => ({

  labs: state.LabReducer.labs,
  lab: state.LabReducer.lab,
  loading: state.LabReducer.isLoading,
});

const mapDispatchToProps = dispatch => ({

  onGetLab: () => dispatch(getLabsListRequest()),
  // onUpdateTest: test => dispatch(updateTestRequest(test)),
  // onUpdateTest: (test, id) =>
  //   dispatch(updateTestRequest(test, id)),
  onDeleteLab: lab => dispatch(deletepLabRequest(lab)),
  onVerifyLab: lab => dispatch(verifyLabRequest(lab)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(VerifiedLabs));
